@if (isInitialized) {
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title" position="bottom">Long-Running Processes</h4>
            <div class="ws-section__header__actions">
                <div class="ws-section__header__actions__item">
                    <label name="autoRefresh"
                           helpTooltip
                           helpContentId="long-running-process-page.auto-refresh"
                           position="bottom">
                        <input name="autoRefresh"
                               type="checkbox"
                               [checked]="autoRefresh"
                               (change)="onAutoRefreshChange()">
                        Auto-refresh
                    </label>
                </div>
                <div class="ws-section__header__actions__item">
                    <button type="button"
                            class="ace-btn btn-sm btn-secondary has-icon"
                            (click)="refresh()"
                            [disabled]="refreshing"
                            helpTooltip
                            helpContentId="app.refresh"
                            position="bottom">
                        <i class="fa fa-refresh"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <long-running-process-quiesce [canEdit]="canEdit"></long-running-process-quiesce>
    <long-running-process-list [canEdit]="canEdit"></long-running-process-list>
}
